var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPaymentHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 246.248,
    height: 194.603,
    viewBox: "0 0 246.248 194.603",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17332",
    "data-name": "Rectangle 17332",
    width: 63.067,
    height: 48.105,
    fill: "#d74141"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-payment-history",
    transform: "translate(-35.36 -60.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17669",
    "data-name": "Group 17669",
    transform: "translate(35.36 60.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10811",
    "data-name": "Path 10811",
    d: "M148.248,232.158H57.769c-12.52,0-31.071-18.209-17.867-36.812s29.94-28.87,25.035-51.711-14.3-45.668,1.208-61.952c20.236-21.248,71.981,9.722,94.787-1.368s63.871-29.6,88.395-13,8.033,70.285,12.939,84.1,14.749,13.543,18.595,35.931c3.671,21.374-6.521,42.892-23.5,42.892C243.4,230.234,148.248,232.158,148.248,232.158Z",
    transform: "translate(-35.36 -60.689)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10812",
    "data-name": "Path 10812",
    d: "M150.388,234.482H61.957c-7.744,0-27.288-18.642-14.382-36.824s26.182-27.371,21.388-49.7S57.042,106.267,72.2,90.354c19.778-20.768,69.821,3.125,92.11-7.716s60.9-25.5,84.872-9.27,7.852,68.694,12.645,82.195S276.239,168.8,280,190.68c3.588,20.89-6.374,41.921-22.967,41.921C243.387,232.6,150.388,234.482,150.388,234.482Z",
    transform: "translate(-38.735 -63.014)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17651",
    "data-name": "Group 17651",
    transform: "translate(170.542 26.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17649",
    "data-name": "Group 17649",
    transform: "translate(0.79 0.787)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 9.549,
    cy: 9.549,
    r: 9.549,
    transform: "matrix(0.159, -0.987, 0.987, 0.159, 0, 18.854)",
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    "data-name": "Ellipse 106",
    cx: 8.365,
    cy: 8.365,
    r: 8.365,
    transform: "matrix(0.608, -0.794, 0.794, 0.608, 0, 13.289)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17650",
    "data-name": "Group 17650",
    transform: "translate(8.92 5.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10813",
    "data-name": "Path 10813",
    d: "M350.515,129.417V127.9a4.375,4.375,0,0,1-2.3-.661l.361-1.007a4.006,4.006,0,0,0,2.163.647c1.068,0,1.789-.616,1.789-1.473,0-.826-.586-1.338-1.7-1.789-1.534-.6-2.481-1.292-2.481-2.6a2.466,2.466,0,0,1,2.27-2.42v-1.518h.932v1.457a4.016,4.016,0,0,1,1.954.526l-.375.992a3.636,3.636,0,0,0-1.894-.511c-1.157,0-1.593.692-1.593,1.293,0,.781.556,1.173,1.864,1.713,1.548.631,2.329,1.413,2.329,2.751a2.614,2.614,0,0,1-2.375,2.555v1.562h-.948Z",
    transform: "translate(-348.215 -117.077)",
    fill: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17652",
    "data-name": "Group 17652",
    transform: "translate(40.599 31.648)",
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10814",
    "data-name": "Path 10814",
    d: "M21.612,1A20.711,20.711,0,0,0,8.495,5.724V4.748a1.874,1.874,0,1,0-3.748,0v5.622c0,.047.022.088.026.135a1.894,1.894,0,0,0,.071.352,1.939,1.939,0,0,0,.116.337,1.857,1.857,0,0,0,.187.292,1.745,1.745,0,0,0,.139.208c.034.034.08.047.114.077s.052.071.088.1a1.8,1.8,0,0,0,.2.1,1.784,1.784,0,0,0,.349.163,1.814,1.814,0,0,0,.345.069,1.874,1.874,0,0,0,.236.045h5.622a1.874,1.874,0,1,0,0-3.748h-1.2A16.847,16.847,0,1,1,4.747,21.612a1.874,1.874,0,1,0-3.748,0A20.612,20.612,0,1,0,21.612,1Z",
    transform: "translate(-1 -1)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10815",
    "data-name": "Path 10815",
    d: "M16.369,19.99a1.874,1.874,0,0,0,1.874-1.874V6.874a1.874,1.874,0,1,0-3.748,0v9.369H8.874a1.874,1.874,0,1,0,0,3.748Z",
    transform: "translate(4.243 2.495)",
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17656",
    "data-name": "Group 17656",
    transform: "translate(185.009 50.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17654",
    "data-name": "Group 17654",
    transform: "translate(0.941 0.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17653",
    "data-name": "Group 17653",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 11.374,
    cy: 11.374,
    r: 11.374,
    transform: "matrix(0.159, -0.987, 0.987, 0.159, 0, 22.458)",
    fill: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 9.964,
    cy: 9.964,
    r: 9.964,
    transform: "matrix(0.608, -0.794, 0.794, 0.608, 0, 15.829)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17655",
    "data-name": "Group 17655",
    transform: "translate(10.625 6.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10816",
    "data-name": "Path 10816",
    d: "M350.954,131.772v-1.808a5.212,5.212,0,0,1-2.739-.788l.431-1.2a4.771,4.771,0,0,0,2.578.77c1.272,0,2.13-.734,2.13-1.755,0-.985-.7-1.593-2.023-2.13-1.826-.716-2.954-1.54-2.954-3.1a2.94,2.94,0,0,1,2.7-2.884v-1.808h1.11v1.736a4.783,4.783,0,0,1,2.327.627l-.447,1.182a4.331,4.331,0,0,0-2.256-.609c-1.378,0-1.9.824-1.9,1.54,0,.931.663,1.4,2.22,2.041,1.843.752,2.775,1.683,2.775,3.276a3.116,3.116,0,0,1-2.829,3.045v1.862h-1.129Z",
    transform: "translate(-348.215 -117.072)",
    fill: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17660",
    "data-name": "Group 17660",
    transform: "translate(163.746 71.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17658",
    "data-name": "Group 17658",
    transform: "translate(1.116 1.111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17657",
    "data-name": "Group 17657",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 13.503,
    cy: 13.503,
    r: 13.503,
    transform: "matrix(0.159, -0.987, 0.987, 0.159, 0, 26.661)",
    fill: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 11.829,
    cy: 11.829,
    r: 11.829,
    transform: "matrix(0.608, -0.794, 0.794, 0.608, 0, 18.791)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17659",
    "data-name": "Group 17659",
    transform: "translate(12.613 7.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10817",
    "data-name": "Path 10817",
    d: "M351.467,134.525v-2.146a6.187,6.187,0,0,1-3.252-.935l.511-1.425a5.664,5.664,0,0,0,3.061.914c1.509,0,2.529-.871,2.529-2.083,0-1.169-.829-1.892-2.4-2.529-2.168-.85-3.507-1.828-3.507-3.677a3.488,3.488,0,0,1,3.21-3.422v-2.146h1.322v2.061a5.679,5.679,0,0,1,2.764.744l-.53,1.4a5.141,5.141,0,0,0-2.678-.721c-1.636,0-2.253.978-2.253,1.828,0,1.1.787,1.658,2.635,2.423,2.189.892,3.294,2,3.294,3.889a3.7,3.7,0,0,1-3.358,3.613v2.211h-1.34Z",
    transform: "translate(-348.215 -117.075)",
    fill: "#9b9b9b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17665",
    "data-name": "Group 17665",
    transform: "translate(36.847 56.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10818",
    "data-name": "Path 10818",
    d: "M189.645,186.753l-.125,28.122-.031,8.034-.125,28.116c0,15.166-6.478,27.53-14.593,28.1-.193.012-.386.019-.579.019H126.625v-.006c4-.16,7.617-3.192,10.281-8.028,2.813-5.1,4.555-12.216,4.555-20.081l.031-55.944.006-8.326c0-15.526,9.988-28.115,22.316-28.115,6.08,0,11.587,3.068,15.62,8.034a32,32,0,0,1,6.7,20.081Z",
    transform: "translate(-111.119 -158.638)",
    fill: "#dfdcdc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17662",
    "data-name": "Group 17662",
    transform: "translate(0 36.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10819",
    "data-name": "Path 10819",
    d: "M129.968,222.164l-.006,14.139-.006,3.572v8l-.006,4.431v8l-.006,3.578v8l-.006,4.431v1.8c0,.6-.013,1.189-.031,1.773q-.075,2.268-.343,4.424c-.143,1.226-.336,2.421-.566,3.578a41.342,41.342,0,0,1-1.139,4.424,32.955,32.955,0,0,1-1.344,3.572,25.691,25.691,0,0,1-1.132,2.309,24.034,24.034,0,0,1-1.307,2.123,17.094,17.094,0,0,1-3.236,3.572,9.73,9.73,0,0,1-5.737,2.333c-.112.006-.224.006-.336.006-8.383,0-15.172-12.589-15.172-28.115V222.164h30.374Z",
    transform: "translate(-99.594 -222.164)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17661",
    "data-name": "Group 17661",
    transform: "translate(7.443 14.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10820",
    "data-name": "Path 10820",
    d: "M135.5,246.813l-.006,3.572h-22.92v-3.572Z",
    transform: "translate(-112.569 -246.813)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17324",
    "data-name": "Rectangle 17324",
    width: 22.919,
    height: 3.572,
    transform: "translate(0 8.003)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17325",
    "data-name": "Rectangle 17325",
    width: 22.913,
    height: 3.572,
    transform: "translate(0 16.005)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    d: "M135.483,288.655l-.006,3.578H112.569v-3.578Z",
    transform: "translate(-112.569 -264.653)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17326",
    "data-name": "Rectangle 17326",
    width: 22.907,
    height: 3.572,
    transform: "translate(0 32.005)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10822",
    "data-name": "Path 10822",
    d: "M135.47,316.557v1.8c0,.6-.013,1.189-.031,1.773H112.57v-3.572h22.9Z",
    transform: "translate(-112.57 -276.55)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10823",
    "data-name": "Path 10823",
    d: "M135.379,330.5c-.143,1.226-.336,2.421-.566,3.578H113.8c-.236-1.158-.43-2.352-.566-3.578Z",
    transform: "translate(-112.852 -282.496)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10824",
    "data-name": "Path 10824",
    d: "M134.936,344.449a32.946,32.946,0,0,1-1.344,3.572H117.531a32.95,32.95,0,0,1-1.338-3.572Z",
    transform: "translate(-114.114 -288.443)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10825",
    "data-name": "Path 10825",
    d: "M133.97,358.4a17.092,17.092,0,0,1-3.236,3.572h-4.7A16.9,16.9,0,0,1,122.8,358.4Z",
    transform: "translate(-116.931 -294.391)",
    fill: "#d8d8d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17664",
    "data-name": "Group 17664",
    transform: "translate(52.693 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10826",
    "data-name": "Path 10826",
    d: "M261.918,186.752H213.771a31.993,31.993,0,0,0-6.7-20.081c-4.032-4.967-9.54-8.034-15.62-8.034H239.6C251.93,158.637,261.918,171.226,261.918,186.752Z",
    transform: "translate(-191.455 -158.637)",
    fill: "#c5c5c5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17663",
    "data-name": "Group 17663",
    transform: "translate(10.569 1.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10827",
    "data-name": "Path 10827",
    d: "M256.889,164.829H215.463a20.951,20.951,0,0,0-5.582-3.578h41.438a20.973,20.973,0,0,1,5.57,3.578Z",
    transform: "translate(-209.881 -161.251)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10828",
    "data-name": "Path 10828",
    d: "M270.028,178.773H228.6a27.49,27.49,0,0,0-2.128-3.572H267.9A28.156,28.156,0,0,1,270.028,178.773Z",
    transform: "translate(-216.953 -167.199)",
    fill: "#d8d8d8"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10829",
    "data-name": "Path 10829",
    d: "M258.092,194.7V307.671H189.256a10.356,10.356,0,0,1-1.394-.1,10.894,10.894,0,0,1-1.13-.214,10.379,10.379,0,0,1-7.843-10.058V249.146a33.493,33.493,0,0,1,15.86-61.481c.815-.062,1.63-.09,2.457-.09h53.763A7.121,7.121,0,0,1,258.092,194.7Z",
    transform: "translate(-90.048 -114.791)",
    fill: "#acacac"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17666",
    "data-name": "Group 17666",
    transform: "translate(102.466 77.774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10830",
    "data-name": "Path 10830",
    d: "M280.29,313.1H216.446a2.458,2.458,0,0,1-2.458-2.458V198.732a2.458,2.458,0,0,1,2.458-2.458h63.843a2.458,2.458,0,0,1,2.458,2.458V310.644a2.458,2.458,0,0,1-2.459,2.458Z",
    transform: "translate(-213.988 -196.274)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17327",
    "data-name": "Rectangle 17327",
    width: 62.393,
    height: 98.536,
    transform: "translate(3.185 6.529)",
    fill: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    cx: 4.159,
    cy: 4.159,
    r: 4.159,
    transform: "translate(29.902 106.787)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10831",
    "data-name": "Path 10831",
    d: "M275.045,202.236H260.972a.921.921,0,0,1-.921-.921v-.544a.921.921,0,0,1,.921-.921h14.073a.921.921,0,0,1,.921.921v.544A.921.921,0,0,1,275.045,202.236Z",
    transform: "translate(-233.628 -197.799)",
    fill: "#cecece"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10832",
    "data-name": "Path 10832",
    d: "M313.011,239.69h-.3a1.776,1.776,0,0,0-1.777,1.777V299.7a1.777,1.777,0,0,0,1.777,1.777h.3a1.777,1.777,0,0,0,1.777-1.777V241.467A1.777,1.777,0,0,0,313.011,239.69Z",
    transform: "translate(-152.857 -137.011)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17668",
    "data-name": "Group 17668",
    transform: "translate(161.931 109.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17667",
    "data-name": "Group 17667",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10833",
    "data-name": "Path 10833",
    d: "M289.5,256.148v39.034a4.535,4.535,0,0,0,4.535,4.535h68.123a4.535,4.535,0,0,0,4.535-4.535V256.148a4.535,4.535,0,0,0-4.536-4.535H294.036a4.535,4.535,0,0,0-4.536,4.536Z",
    transform: "translate(-305.65 -251.613)",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17328",
    "data-name": "Rectangle 17328",
    width: 16.844,
    height: 4.535,
    transform: "translate(41.525 27.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17329",
    "data-name": "Rectangle 17329",
    width: 16.844,
    height: 4.535,
    transform: "translate(23.192 27.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17330",
    "data-name": "Rectangle 17330",
    width: 16.844,
    height: 4.535,
    transform: "translate(4.858 27.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17331",
    "data-name": "Rectangle 17331",
    width: 16.844,
    height: 4.535,
    transform: "translate(-13.475 27.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10834",
    "data-name": "Path 10834",
    d: "M399.92,271.588H388.965a2.028,2.028,0,0,1-2.028-2.028v-5.6a2.028,2.028,0,0,1,2.028-2.028h10.954a2.028,2.028,0,0,1,2.028,2.028v5.6a2.028,2.028,0,0,1-2.027,2.029Z",
    transform: "translate(-347.194 -256.012)",
    fill: "#d8d8d8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10835",
    "data-name": "Path 10835",
    d: "M211.924,187.727a33.274,33.274,0,0,0-4.126.556,9.426,9.426,0,0,0-3.89,7.629V307.426a10.763,10.763,0,0,0,1.13.214.737.737,0,0,1-.006-.113V195.912A8.318,8.318,0,0,1,211.924,187.727Z",
    transform: "translate(-107.225 -114.856)",
    fill: "#818181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPaymentHistory);
export default __webpack_public_path__ + "static/media/no-payment-history.fe518367c4d5800c568e73ee5cc3b18d.svg";
export { ForwardRef as ReactComponent };